import { QIcon_certified } from '@repo/icons/index'
import { STACK_ACTIVITY_NAME } from '../../../modules/hooks/common/appRouterVars'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import LinkLocale from '../../../modules/i18n/LinkLocale'
import urls from '../../../modules/urls'
import { buildSanityImage } from '../../../modules/utils'
import { COLORS } from '../../../modules/vars'
import { useBlogStack } from '../../../pages/[lang]/webview/blog'
import { useHelpCenterStack } from '../../../pages/[lang]/webview/help-center'

const BlogMobileMainPostSection = ({ thumbnail, mainPost }) => {
  const { title, subtitle, tagLists } = mainPost
  const { useBlogFlow } = useBlogStack()
  const { push } = useBlogFlow()
  const appRouter = useAppRouter({ stackPush: push })

  const { useHelpCenterFlow } = useHelpCenterStack()
  const { push: helpPush } = useHelpCenterFlow()
  const helpRouter = useAppRouter({ stackPush: helpPush })
  return (
    <div className={style.mainPostSectionLayout}>
      <div className={style.descriptionSectionWrapper}>
        <div className={style.editorPickLayout}>
          <QIcon_certified color={COLORS.PURPLE500} width={28} height={28} />
          <div className={style.editorTitle}>Editor’s Pick</div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() =>
            appRouter.asPath.includes('help-center')
              ? helpRouter.push(urls.student.landing.blog.detail(mainPost.slug.current), {
                  stackActivity: STACK_ACTIVITY_NAME.HELP_CENTER_DETAIL_ACTIVITY,
                  stackSendData: {
                    slug: mainPost.slug.current,
                  },
                })
              : appRouter.push(urls.student.landing.blog.detail(mainPost.slug.current), {
                  stackActivity: STACK_ACTIVITY_NAME.BLOG_DETAIL_ACTIVITY,
                  stackSendData: {
                    slug: mainPost.slug.current,
                  },
                })
          }
        >
          <img
            loading="lazy"
            src={buildSanityImage(thumbnail).url()}
            className="w-full rounded-[8px] object-cover"
            alt={thumbnail.alt}
          />

          <div className={style.descriptionSection}>
            <div>
              <div className={style.descriptionCategoryWrapper}>
                <div className="">{mainPost.category}</div>
                <div className="border-r-1 mx-[12px] h-[12px]"></div>
                <div className="">{mainPost.subCategory}</div>
              </div>

              <div className={style.desciprtionTitle}>{title}</div>
              {subtitle && <span className={style.descriptionSubtitle}>{subtitle}</span>}
            </div>
            <div className={style.desciprtionTagSection}>
              {tagLists.map((tagItem, i) => {
                return (
                  <LinkLocale key={i} href={urls.student.landing.blog.tags(tagItem)}>
                    <div className={style.desciprtionTags}>{tagItem}</div>
                  </LinkLocale>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlogMobileMainPostSection

const style = {
  mainPostSectionLayout: ` mb-[52px] flex cursor-pointer flex-col bg-[#EBE6FA]`,
  mainPostSectionWrapper: `py-[45px]`,
  editorPickLayout: `mb-[12px] flex flex-row items-center`,
  editorTitle: `Headline2-24Bd ml-[4px]`,
  descriptionSectionWrapper: `border-t-1 border-b-1 w-full px-[16px] pt-[34px] pb-[32px]`,
  descriptionSection: `mt-[20px] flex h-full flex-col justify-between`,
  descriptionCategoryWrapper: `Body2-14Md flex flex-row items-center text-gray-700`,
  desciprtionTitle: `truncate-2-lines Headline2-24Bd keep-all my-[12px]`,
  desciprtionTagSection: `mt-[40px] flex flex-row gap-[8px]`,
  desciprtionTags: `Caption-12Bd flex rounded-[4px] bg-gray-100 py-[2px] px-[6px] text-gray-600`,
  descriptionSubtitle: `truncate-3-lines keep-all Body1-16Md min-h-[42px]  text-gray-700`,
}
